import { render, staticRenderFns } from "./tiyouyouParentsBook.vue?vue&type=template&id=37087831&"
import script from "./tiyouyouParentsBook.vue?vue&type=script&lang=js&"
export * from "./tiyouyouParentsBook.vue?vue&type=script&lang=js&"
import style0 from "./tiyouyouParentsBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports